/* --------------------------------------------------------------------------------------
   results.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

import { reportsComponent, reportsCtrl } from './components/reports.component'
import { resultsService } from './services/results.service'

const resultsComponent =  {
  template: require('./results.html'),
  controller: 'resultsCtrl',
  controllerAs: 'vm'
}

class resultsCtrl {
    /*@ngInject*/
  constructor ($state) {
    this.$state = $state
  }
  $onInit () {
    this.step = 0;
  }
  back() {
    this.step--
    if (this.step < 0)
      this.$state.go('main')
    }
  next () {
    this.step++
    if (this.step > 3)
      this.print()
  }
}

export const appResultsModule = angular.module('app.results', ['ui.router','app.common'])
  .component('results', resultsComponent)
  .controller('resultsCtrl', resultsCtrl)
  .component('reports', reportsComponent)
  .controller('reportsCtrl', reportsCtrl)
  .service('resultsService',resultsService)



// WEBPACK FOOTER //
// ./src/app/results/results.js